// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"27790593c96eeef2","101":"7a4c5a39ba898c1a","659":"cb94c1a0e312b885"}[chunkId] + ".js";
};